import React, { Component } from 'react';
import { Tabs, Tab, Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import Users from './Users';
import SubcontractorTabs from '../../SubContractor/SubcontractorTabs';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Typography component={'span'} variant={'body2'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class UsersTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabValue: 0,
            isLoading: true,
            userAccess: props.access ? props.access : {},
        }
    }

    handleViewType(e, newValue) {
        this.setState({ tabValue: newValue })
    }

    render() {
        return (
            <div>
                <Tabs
                    value={this.state.tabValue}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(e, newValue) => this.handleViewType(e, newValue)}
                    aria-label="Role Tabs"
                    centered >
                    <Tab label="Internal" />
                    <Tab label="External" />
                </Tabs>

                <TabPanel value={this.state.tabValue} index={0}>
                    <Users access={this.state.userAccess} link={true} />
                </TabPanel>

                <TabPanel value={this.state.tabValue} index={1}>
                    <SubcontractorTabs />
                </TabPanel>

            </div>
        );
    }
}

export default UsersTab;